import React, { useState, useEffect, Fragment } from 'react'
import * as signalR from '@microsoft/signalr'
import AuthService from '../services/AuthService'
import { useDispatch } from 'react-redux'
import { getNotificationList, receiveNotification } from '../state/actions/notification'
import PushNotificationContainer from '../components/common/PushNotificationContainer'
import { withAuth } from './AuthProvider'

const SignalRProvider = ({ children, auth }) => {

  const authService = new AuthService.authServiceInstance()
  const dispatch = useDispatch()

  const [connection, setConnection] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [isConnected, setConnected] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => { 
    if (auth?.loggedIn) initConnection() 
  }, [auth?.loggedIn]);

  useEffect(() => { 
    if (auth?.loggedIn) startConnection() 
  }, [connection, isConnected, retryCount, auth?.loggedIn]);

  const initConnection = () => {
    authService.getUser().then(res => {
      if (res) {
        getNotifications();
        setUser(res);

        const url = process.env.SIGNALR_PUSHHUB_URL;    
        const newConnection = new signalR.HubConnectionBuilder()
          .withUrl(url, {
            accessTokenFactory: () => res.access_token
          })
          .withAutomaticReconnect()
          .build();

        setConnection(newConnection);
      }
    }).catch(err => console.error(err))
  }

  const startConnection = () => {
    if (connection && !isConnected && retryCount < 5) {

      connection.start()
        .then(result => {
          console.log('Connected!');
          setConnected(true);
          connection.on('Notify', message => {
            const notification = JSON.parse(message.cargo);
            dispatch(receiveNotification(notification))
          });

          connection.on("disconnected", function () {
            console.log("Disconnected. Trying to Reconnect...")
            setConnected(false);
            setRetryCount(0);
          });

          const register = {
            companyKey: user.profile.sub,
            entityType: "DevPortal",
            entityID: 1
          };

          connection.invoke('RegisterListener', register).then(res => {
            console.log("User listening to notifications, group:", `${register.companyKey}.${register.entityType}.${register.entityID}`);
          }).catch(err => {
            console.log(err);
          });
        })
        .catch(e => {
          console.log('Connection failed: ', e)
          setTimeout(() => setRetryCount((count) => count + 1), 5000);
        });
    }
    else {
      if (retryCount > 5) {
        console.log("Unable to connect to SignalR")
      }
    }
  }

  const getNotifications = () => {
    dispatch(getNotificationList(1));
  }

  return (
    <Fragment>
      {children}
      <PushNotificationContainer />
    </Fragment>
  )
}

export default withAuth(SignalRProvider);


